export default __webpack_public_path__ + "static/media/logo.b6357c49.png";